// Add/remove rows on the admin order edit form. The markup for a new row is
// the Symfony collection prototype rendered through the very same partial as
// the existing rows (see edit.html.twig), so there is no second copy of the
// row layout to keep in sync here.
function initOrderLines() {
    document.querySelectorAll('[data-order-lines]').forEach((container) => {
        const list = container.querySelector('[data-order-lines-list]');
        const addButton = container.querySelector('[data-order-lines-add]');

        if (!list || !addButton) {
            return;
        }

        // Keeps climbing past the rows already on screen: Symfony only needs
        // the indexes to be unique, never contiguous, so removing a row in
        // the middle can't make the next one collide with it.
        let nextIndex = parseInt(container.dataset.orderLinesIndex, 10) || list.children.length;

        addButton.addEventListener('click', () => {
            const row = document.createElement('div');
            row.innerHTML = container.dataset.orderLinesPrototype.replace(/__line__/g, nextIndex);
            nextIndex += 1;

            const line = row.firstElementChild;
            if (line) {
                list.appendChild(line);
                line.querySelector('select, input')?.focus();
            }
        });

        list.addEventListener('click', (event) => {
            const removeButton = event.target.closest('[data-order-line-remove]');

            if (removeButton) {
                removeButton.closest('[data-order-line]')?.remove();
            }
        });
    });
}

export default initOrderLines;
